import { esc } from "../../utils/format.js";
export function head(label, title, sub, actions = "") {
  return (
    <div className={"page-head"}>
      <div>
        <div className={"eyebrow"}>{label}</div>
        <h1>{esc(title)}</h1>
        <p>{esc(sub)}</p>
      </div>
      <div className={"head-actions"}>{actions}</div>
    </div>
  );
}
